import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import Link from 'components/Link';
import * as ProductIcons from 'components/ProductIcons';
import * as NotProductIcons from 'components/NotProductIcons';
import { prepareData } from 'utils/googleData';

export default function Enterprises(props) {
  const {
    enable,
    title,
    subtitle,
    gatsbyImage,
    features,
  } = prepareData({ props });

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section className="px-5 py-20 bg-gray-50 dark:bg-[#0B1C39]">
      <div className="max-w-7xl mx-auto">
        {/* Title Section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900 dark:text-white"
            dangerouslySetInnerHTML={{ __html: title }}>
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* Image Section */}
        <div className="flex justify-center mb-20">
          <GatsbyImage
            image={gatsbyImage}
            alt={title}
            className="w-full max-w-[800px] rounded-lg shadow-2xl"
          />
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => {
            const { name, icon, description } = feature;
            const Icon = NotProductIcons[icon] || ProductIcons[icon];
            let cta = feature?.cta;
            if (Array.isArray(cta) && cta.length === 1) cta = cta[0];

            return (
              <div
                key={name}
                className="bg-white dark:bg-[#1B3154] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-center mb-4">
                  {Icon && (
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100 dark:bg-[#2C4268] mr-4 dark:ring-4 dark:ring-[#1B3154]/50">
                      <Icon className="w-6 h-6 text-blue-600 dark:text-[#4BB3FD]" />
                    </div>
                  )}
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{name}</h3>
                </div>
                <p className="text-gray-600 dark:text-[#E5E7EB] mb-4 text-sm leading-relaxed">
                  {description}
                </p>
                {cta && (
                  <Link 
                    to={cta.url}
                    className="text-blue-600 dark:text-[#4BB3FD] hover:text-blue-700 dark:hover:text-[#3AA2EC] font-medium text-sm inline-flex items-center"
                  >
                    {cta.text}
                    <svg className="w-4 h-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
